import { object, string } from 'yup'
import { errorMessages } from '../../../../message/errorMessages'

export const schema = object().shape({
	otp: string().required(errorMessages.user.OTP),
})
